export function removeNonWord(value: string): string {
    return value.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, '');
}
